module.exports = __webpack_public_path__ + "static/logo-8a0d765ae746fe03c118dafc4d12af82.svg";